import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/reportes/puntuaciones';
import PuntuacionesClases from './PuntuacionesClases';


const ms2p = (state) => {
    return {
        ...state.puntuaciones,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(PuntuacionesClases);
